import BaseAPI from './base'

class SchoolExamPeriodDetailAPI extends BaseAPI {}

export default new SchoolExamPeriodDetailAPI('v1/school-exam-period-details', 'SchoolExamPeriodDetail')
